import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate, useParams } from 'react-router-dom';
import { url, isAllowSessionTime, subscriptionKey } from "../../constants";
import { MerchantActions, PermissionActions } from "../../actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faMagic, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { connect } from 'react-redux'
import Notifications from '../../components/Modals/Notifications/notifications'
import { Api } from "../../services/httpService";
import Swal from "sweetalert2";
import LogOut from "../../assests/logout-icon.svg";
import { useIdleTimer } from 'react-idle-timer';
import "../../../src/components/NewOnBoarding/DeshBoard.css"
import CmsModal from '../../components/Modals/CmsModal/CmsModal';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

import logo_ from "../../assests/zelo-logo-new.png"
import NotifyBell from "../../assests/notification-bell-icon.png"
import zIndex from "@material-ui/core/styles/zIndex";
const Header = ({ getNotifications, getAllNotifications, socket, getGenericsStoreProcedure, genericProcedureData, getUserAccessList, userAccess }) => {
    const [notificationsModal, setNotificationsModal] = useState(false)
    let timeLeft = 60;
    const [isProdTourStart, setIsProdTourStart] = useState(false);
    const [subIsUserTour, setIsSubUserTour] = useState(false)
    const [isAllowTermConditions, setIsAllowTermConditions] = useState(false)
    const [isUserAccountStatus, setIsUserAccountStatus] = useState(false)
    const hasCompliancePendingDocs = localStorage.getItem("hasCompliancePendingDocs");
    const path = window.location.pathname;
    /* for idel use */
    const [isIdle, setIsIdle] = useState(false);
    const updateTimerHtml = () => {
        return `<div style="color: #009e49; background: #fff; padding: 10px; border-radius: 5px;">
                    You will be logged out in <b>${timeLeft}</b> seconds.
                </div>`;
    };

    const handleOnIdle = () => {
        setIsIdle(true);

        // Show the Swal alert and store the promise
        Swal.fire({
            title: 'You have been inactive',
            html: updateTimerHtml(),
            icon: 'warning',
            timer: 60 * 1000,
            timerProgressBar: true,
            showCancelButton: false,
            confirmButtonText: 'Stay Logged In',
            allowOutsideClick: true,
            didOpen: () => {
                // Start the timer interval when the alert opens
                const timerInterval = setInterval(() => {
                    if (timeLeft > 0) {
                        timeLeft -= 1;
                        // Update the HTML of the specific Swal instance
                        const htmlContainer = Swal.getHtmlContainer();
                        if (htmlContainer) {
                            htmlContainer.innerHTML = updateTimerHtml();
                        }
                    } else {
                        clearInterval(timerInterval);
                        Swal.close(); // Close the Swal when the timer ends
                        // Perform any additional actions (e.g., logout)
                        Api('post', '/users/logout').then(() => {
                            window.localStorage.clear();

                            localStorage.setItem("isTimeSessionOut", true);
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000)


                        });
                    }
                }, 1000);
            }
        }).then((result) => {
            if (result.isConfirmed) {
                // Reset the idle state and refresh the session
                setIsIdle(false);
                window.location.reload();
            } else if (result.isDismissed && result.dismiss === Swal.DismissReason.timer) {
                const res = Api('post', '/users/logout');
                if (res) {
                    window.localStorage.clear();
                    localStorage.setItem("isTimeSessionOut", true);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)
                }
            } else if (result.isDismissed && result.dismiss === Swal.DismissReason.backdrop) {
                setIsIdle(false);
                window.location.reload();
            }
        });
    };

    const handleOnActive = () => {
        setIsIdle(false);
    };

    useIdleTimer({
        timeout: isAllowSessionTime,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        debounce: 500,
    });


    // let {id} = useParams();
    let id = null;
    const navigate = useNavigate();

    const [state, setState] = useState({
        userName: "",
        company: "",
        documentStatus: '',
        accountStatus: ''
    });

    const closeModal = (data) => {
        if (data) {
            setNotificationsModal(data)
        }
        else {
            setIsAllowTermConditions(false)
        }
    }

    const mystyle = {
        headerstyle: {
            width: '100%',
            zIndex: 1000
        },
        namestyle: {
            left: '100%' - 165
        },
        solidcircle: {
            left: window.innerWidth - 225
        },
        bell: {
            left: window.innerWidth - 280
        },
        username: {
            left: window.innerWidth - 170
        },
        logoutBtn: {
            left: window.innerWidth - 100,
            marginTop: 20
        }

    };

    const checkPermission = (value) => {
        if (!Array.isArray(userAccess)) {
            console.error("userAccess is not an array or is null/undefined");
            return false;
        }
        return userAccess?.some(item => item.allow_action === value);
    }

    useEffect(() => {
        if (localStorage.getItem("_id")) {
            id = localStorage.getItem("_id");
            // getNotifications(id)
            getGenericsStoreProcedure({ storeProcedureName: "unReadNotificationCount", merchantId: id }).then(() => {
            });
            getUserAccessList(window.localStorage.getItem("_roleId"), 'menu_access'); /* call api for menu access check */
        }
        else {
            navigate(`/user`);
        }
        loadMerchantData(id);
        if (socket) {
            socket.on('notificationsGenerate', () => {
                // getNotifications(id)
                getGenericsStoreProcedure({ storeProcedureName: "unReadNotificationCount", merchantId: id }).then(() => {
                });
            })

            /*  call socket for permission check */
            socket.on('permissionSocket', () => {
                getUserAccessList(window.localStorage.getItem("_roleId"), 'menu_access'); /* call api for menu access check */
                window.location.reload();
            });

            socket.on("tokenExpired", (param) => {
                const resToken = 'Bearer ' + param;
                let currentToken = localStorage.getItem("_token");
                if (resToken === currentToken) {
                    const res = Api('post', '/users/logout');
                    if (res) {
                        window.localStorage.clear();
                        localStorage.setItem("isTimeSessionOut", true);
                        window.location.reload();
                    }
                }
            })

            /* check for status update */

            socket.on("documentUpdated", () => {
                window.location.reload();
            })
        }

    }, [socket]);

    const loadMerchantData = async (id) => {
        const apiUrl = `${url}/merchant/${id}`;
        let tokenHeader = "";
        if (localStorage.getItem("_token")) {
            tokenHeader = localStorage.getItem("_token");
        }
        fetch(apiUrl, { headers: { "Ocp-Apim-Subscription-Key": subscriptionKey, "Authorization": tokenHeader } })
            .then((res) => res.json())
            .then((data) => {
                setIsUserAccountStatus(data?.body?.accountStatus);
                localStorage.setItem('accountStatus', data?.body?.accountStatus);
                localStorage.setItem('defCompanyName', data?.body?.companies?.[0]?.tradeName);
                localStorage.setItem("hasCompliancePendingDocs", data?.body?.hasCompliancePendingDocs ? data?.body?.hasCompliancePendingDocs : '');
                const userdata = data.body;
                setIsSubUserTour(userdata.user.subUser ? false : true)
                const temp = { ...state };
                temp.name = userdata.user.name;
                temp.company = userdata.companies?.[0].designation;
                temp.documentStatus = data.body.documentStatus;
                temp.accountStatus = data.body.accountStatus;
                setState(temp);
            })
            .catch(() =>
                console.log("Can’t access " + apiUrl + " response. Blocked by browser?")
            );
    };

    const LogOutHandler = async () => {
        Swal.fire({
            title: 'Are you sure!',
            text: 'Do you want to logout?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            allowOutsideClick: false,
            confirmButtonColor: "var(--bg-theme)",
        }).then(result => {
            if (result.isConfirmed) {
                const res = Api('post', '/users/logout');
                if (res) {
                    window.localStorage.clear();
                    window.location.reload();
                }
            }
        });
    }

    if (getAllNotifications) {
        var unreadNotificationCount = getAllNotifications.filter((item) => {
            return item.flag === 0
        })
        // {setNotificationCount(unreadNotificationCount)}
    }

    /* Call Product Tour code */
    var wasTourEndedEarly = false;

    function fetchAndInjectCustomStyles() {
        var token = localStorage.getItem('_token');
        if (!token) {
            console.error('No bearer token found in local storage');
            return;
        }

        var apiUrl = `${url}/common/getGenericSPData/tourCss`;

        fetch(apiUrl, {
            headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                'Authorization': token
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success && data.body && data.body.length > 0) {
                    var styleContent = Object.values(data.body[0])[0];
                    injectCustomStyles(styleContent);
                } else {
                    console.error('Failed to fetch tour CSS:', data.message);
                }
            })
            .catch(error => {
                console.error('Error fetching tour CSS:', error);
            });
    }

    function injectCustomStyles(cssContent) {
        var style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = cssContent;
        document.head.appendChild(style);
    }

    function startProductTour() {
        var pageUrl = encodeURIComponent(window.location.pathname + window.location.search);
        var token = localStorage.getItem('_token');
        var bptype = localStorage.getItem('@buyerPlatformType');
        if (!token) {
            setIsProdTourStart(false);
            console.error('No bearer token found in local storage');
            return;
        }

        var apiUrl = `${url}/common/getGenericSPData/getProductTourSteps?pageurl=` + pageUrl + '&bptype=' + bptype + '&Onboarding=0';

        fetch(apiUrl, {
            headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                'Authorization': token
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success && data.body) {
                    if (typeof introJs === 'undefined') {
                        var script = document.createElement('script');
                        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/intro.js/7.2.0/intro.min.js';
                        document.head.appendChild(script);

                        var link = document.createElement('link');
                        link.rel = 'stylesheet';
                        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/intro.js/7.2.0/introjs.min.css';
                        injectCustomStyles();
                        document.head.appendChild(link);

                        script.onload = function () {
                            fetchAndInjectCustomStyles();
                            executeToursSequentially(data.body);
                        };
                    } else {
                        fetchAndInjectCustomStyles();
                        executeToursSequentially(data.body);
                    }
                } else {
                    setIsProdTourStart(false);
                    console.error('Failed to fetch tour steps:', data.message);
                }
            })
            .catch(error => {
                console.error('Error fetching tour steps:', error);
                setIsProdTourStart(false);
            });

        // Reset the wasTourEndedEarly flag each time the tour is started
        wasTourEndedEarly = false;
    }

    function startOboardingTour() {
        var pageUrl = encodeURIComponent(window.location.pathname + window.location.search);

        var token = localStorage.getItem('_token');
        var bptype = localStorage.getItem('@buyerPlatformType');
        if (!token) {
            console.error('No bearer token found in local storage');
            return;
        }

        var apiUrl = `${url}/common/getGenericSPData/getProductTourSteps?pageurl=` + pageUrl + '&bptype=' + bptype + '&Onboarding=1';

        fetch(apiUrl, {
            headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                'Authorization': token
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success && data.body) {
                    if (typeof introJs === 'undefined') {
                        var script = document.createElement('script');
                        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/intro.js/7.2.0/intro.min.js';
                        document.head.appendChild(script);

                        var link = document.createElement('link');
                        link.rel = 'stylesheet';
                        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/intro.js/7.2.0/introjs.min.css';
                        injectCustomStyles();
                        document.head.appendChild(link);

                        script.onload = function () {
                            fetchAndInjectCustomStyles();
                            executeToursSequentially(data.body);
                        };
                    } else {
                        fetchAndInjectCustomStyles();
                        executeToursSequentially(data.body);
                    }
                } else {
                    console.error('Failed to fetch tour steps:', data.message);
                    setIsProdTourStart(false);
                }
            })
            .catch(error => {
                console.error('Error fetching tour steps:', error);
                setIsProdTourStart(false);
            });

        // Reset the wasTourEndedEarly flag each time the tour is started
        wasTourEndedEarly = false;
    }

    function executeToursSequentially(steps) {
        if (wasTourEndedEarly || steps.length === 0) {
            setIsProdTourStart(false);
            return;
        }

        var step = steps.shift();
        var isLastStep = steps.length === 0;

        if (step.isClickable === 1) {
            var elementToClick = document.querySelector(step.element);
            if (elementToClick) {
                elementToClick.click();
            }
            setTimeout(function () {
                executeToursSequentially(steps);
            }, 500);
        } else {
            startIntroJsTour([step], isLastStep, function (wasSkipped) {
                setTimeout(function () {
                    executeToursSequentially(steps);
                }, 100);
            });
        }
    }

    function startIntroJsTour(steps, isLastStep, onTourEndCallback) {
        var intro = introJs();
        var wasSkipped = false;

        intro.setOptions({
            steps: steps,
            showBullets: false,
            showProgress: false,
            showStepNumbers: false,
            exitOnOverlayClick: false,
            exitOnEsc: false,
            buttonLabels: {
                done: isLastStep ? 'Done' : 'Next',
                skip: ''
            },
            // overlayOpacity: 0,
            disableInteraction: true,
            tooltipClass: 'custom-tooltip',
            highlightClass: 'custom-highlight'
        });

        intro.onafterchange(function (targetElement) {
            var currentStepIndex = this._currentStep;
            var currentStep = steps[currentStepIndex];

            var doneButton = document.querySelector('.introjs-donebutton');
            if (doneButton && !isLastStep) {
                doneButton.textContent = 'Next';
            }

            var skipButton = document.createElement('button');
            skipButton.textContent = 'End Tour';
            skipButton.className = 'introjs-button end-tour-button';
            skipButton.style.marginLeft = '5px';
            skipButton.style.marginRight = '5px';
            skipButton.onclick = function () {
                wasSkipped = true;
                wasTourEndedEarly = true;
                intro.exit();
                setIsProdTourStart(false);
            };

            var buttonLayer = document.querySelector('.introjs-tooltipbuttons');
            if (buttonLayer) {
                buttonLayer.appendChild(skipButton);
            }

            /* code for close tour on click close icon */
            var closeButton = document.querySelector('.introjs-skipbutton');
            closeButton.onclick = function (e) {
                wasSkipped = true;
                wasTourEndedEarly = true;
                intro.exit();
                setIsProdTourStart(false);
            };

            if (currentStep && currentStep.isClickable === 1) {
                targetElement.click();
                setTimeout(() => {
                    wasSkipped = true;
                    intro.exit();
                }, 100);
            }
        });

        intro.onexit(function () {
            console.log("Tour has been onexit");
            if (!wasSkipped) {
                onTourEndCallback(false);
            }
        });

        intro.oncomplete(function (e) {
            console.log("Tour has been completed", e);
        });

        intro.start();
    }

    function callStartTour() {
        setIsProdTourStart(true);
        var bptype = localStorage.getItem('@buyerPlatformType');
        if (bptype && bptype !== "null" && state.documentStatus == 'VERIFIED') {
            startProductTour();
        } else {
            startOboardingTour();
        }
    }

    /* End Product Tour code */
    const addClass = () => {
        const firstElement = document.getElementsByClassName('open')
        // console.log('firstElement', firstElement)
        if (firstElement.length > 0) {
            firstElement[0]?.classList?.remove("open")
        } else {
            var element = document.getElementsByClassName('sidebar')
            element[0]?.classList?.add("open");
        }
    }

    useEffect(() => {
        socktCall()
    }, [])


    const socktCall = () => {
        let merchantLoginId = localStorage.getItem("_id");
        let currentToken = localStorage.getItem("_token");
        // Create a SockJS connection
        const javaSocket = new SockJS(url + '/funderSocket');
        // console.log('javaSocket____________',javaSocket);
        // Create a STOMP client over SockJS
        const headers = { 'Ocp-Apim-Subscription-Key': subscriptionKey };
        const stompClient = new Client({
            webSocketFactory: () => javaSocket,  // Corrected this part to use 'javaSocket'
            connectHeaders: headers,
            debug: (str) => {
                console.log(str);
            },
            onConnect: () => {
                // Subscribe to a topic
                stompClient.subscribe('/ADCB/TokenExpired', (message) => {
                    // console.log('Received message: ', message.body.json());
                    console.log('Received message: ', message.body);
                    if (message.body) {
                        let result = JSON.parse(message.body);
                        const resToken = 'Bearer ' + result.token;
                        if (result && result.from === merchantLoginId && result.text === 'Expired' && resToken === currentToken) {
                            console.log('Expired message: ', message.body);
                            window.localStorage.clear();
                            localStorage.setItem("isTimeSessionOut", true);
                            window.location.reload();
                        }
                    }
                });
            },
            onStompError: (frame) => {
                console.error('Broker reported error: ' + frame.headers['message']);
                console.error('Additional details: ' + frame.body);
            }
        });
        // Activate the client to make the connection
        stompClient.activate();
    };

    const closeCmsModal = () => {
        setOpenModel(false);
    }

    /* add class when status is hold and id is container */
    useEffect(() => {
        const status = localStorage.getItem("accountStatus");
        const el = document.getElementById("container");
        if (el) {
            if (status === "OnHold" || (status === "Active" && hasCompliancePendingDocs)) {
                el.classList.add("contentOnHoldContainer");
            } else {
                el.classList.remove("contentOnHoldContainer");
            }
        }
        return () => {
            if (el) {
                el.classList.remove("contentOnHoldContainer");
            }
        };
    }, []);

    return (
        <div>
            <div className="deshboard-header align-items-center d-flex">
                <div className="top_left_title cursor" onClick={addClass}>
                    <div id="toggle">
                        <div className="one"></div>
                        <div className="two"></div>
                        <div className="three"></div>
                    </div>
                    <img onClick={() => navigate("/")} src={logo_} style={{ width: 114 }} />
                </div>
                <div xs="auto" className={localStorage.getItem('_roleId') != 144 ? "ms-auto right-content d-flex align-items-center" : "right-content"}>
                    {!isProdTourStart && subIsUserTour && localStorage.getItem('_roleId') != 144 && state.accountStatus == "Active" ? (
                        <div className="margicInfo d-inline-block"
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title="Confused? Click for a Guided Page Walkthrough!" style={{ marginRight: '8px' }}>
                            <FontAwesomeIcon icon={faMagic} className="cursor" style={{ color: "#ffffff" }} onClick={() => { callStartTour() }} />
                        </div>
                    ) : ''}

                    {
                        localStorage.getItem('_roleId') == 144 && state.accountStatus == "Active" ?
                            <>
                                <div className="margicInfo d-inline-block me-2" style={{ color: '#fff' }}>Unlock cash for your approved invoices instantly! 🚀</div>
                                <div className="margicInfo d-inline-block me-4 cursor" style={{ color: '#fff', textDecorationLine: 'underline' }} onClick={() => { setIsAllowTermConditions(true) }}>Get Started</div>
                            </>
                            : <></>
                    }

                    <img className="_bell cursor" src={NotifyBell} width={24} height={24} onClick={() => { setNotificationsModal(true) }} />
                    {genericProcedureData?.[0]?.unreadCount && genericProcedureData?.[0]?.unreadCount != 0
                        ? <div className="notify_icn" style={{
                            position: "absolute",
                            right: 100,
                            top: 10,
                            height: 25,
                            width: 25,
                            lineHeight: 1.4,
                            textAlign: "center",
                            borderRadius: 18,
                            backgroundColor: "red"
                        }}>
                            <span style={
                                genericProcedureData?.[0]?.unreadCount && genericProcedureData?.[0]?.unreadCount > 90
                                    ? {
                                        color: "#ffffff",
                                        fontSize: 16,
                                        textAlign: 'center',
                                        borderRadius: 18
                                    } : {
                                        color: "#ffffff",
                                        fontSize: 16,
                                        textAlign: 'center',
                                        borderRadius: 18
                                    }
                            }
                            >
                                {genericProcedureData?.[0]?.unreadCount ? (genericProcedureData?.[0]?.unreadCount > 90 ? "90+" : genericProcedureData?.[0]?.unreadCount) : ''}</span>
                        </div>
                        : ''
                    }
                    <img className="_logout cursor" onClick={() => LogOutHandler()} src={LogOut} width={24} height={24} />
                </div>
            </div>

            {/* show account status messages && expire soon */}
            {
                isUserAccountStatus === "OnHold" && !path.includes('/user/compliance-documents') ? (
                    <div className="onholdCContent">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
                                <path d="M12 9v4"></path>
                                <path d="M12 17h.01"></path>
                            </svg>

                            <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                                Account On Hold —
                            </span>
                            <span style={{ color: '#d32f2f', fontSize: '15px' }}>
                                {
                                    !hasCompliancePendingDocs ? "Your submitted documents are being reviewed by our team. Full account access will be restored once verification is complete." : "Your account is currently on hold. Document submission is required to restore full access. Financing requests and reserve withdrawals are disabled until resolved."
                                }
                            </span>
                        </div>

                        <button
                            className="upload-documents-onhold"
                            onClick={() => navigate(`/user/compliance-documents`)}
                            disabled={hasCompliancePendingDocs ? false : true}
                        >
                            Upload Documents
                        </button>
                    </div>
                ) : isUserAccountStatus === "Active" && hasCompliancePendingDocs && !path.includes('/user/compliance-documents') ? (
                    <div className="onExpSoonContent">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <polyline points="12 6 12 12 16 14"></polyline>
                            </svg>

                            <span style={{ color: '#b45309', fontWeight: 'bold' }}>
                                Action Required —
                            </span>
                            <span style={{ color: '#b45309', fontSize: '15px' }}>
                                One or more compliance documents on your account have expired or are expiring soon. Please upload the updated documents to avoid any disruption to your account.
                            </span>
                        </div>
                        <button
                            className="upload-documents-onexpsession"
                            onClick={() => navigate(`/user/compliance-documents`)}
                        >
                            Upload Documents
                        </button>
                    </div>
                ) : null
            }


            {notificationsModal && getAllNotifications && (
                <Notifications
                    openModal={notificationsModal}
                    closeModal={() => { setNotificationsModal(false) }}
                    data={getAllNotifications ? getAllNotifications : []}
                />
            )}

            {
                isAllowTermConditions ?
                    <CmsModal
                        openModal={isAllowTermConditions}
                        closeModal={() => closeModal()}
                        modalTitle="Terms & Conditions"
                        isAllowBuyrToMer={isAllowTermConditions}
                    />
                    : <></>
            }
        </div>
    );
}
const mapStateToProps = ({ MerchantListReducer, PermissionReducers }) => {
    return {
        getAllNotifications: MerchantListReducer.getNotifications,
        genericProcedureData: MerchantListReducer.genericProcedureNotificationCount,
        userAccess: PermissionReducers.userAccess,
    }
}
const mapDispatchToProps = {
    getNotifications: MerchantActions.getNotifications,
    getGenericsStoreProcedure: MerchantActions.getGenericsStoreProcedure,
    getUserAccessList: PermissionActions.getUserAccessList,
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);